/* MYOP video reel — autoplay muted clips while in view, pause out of view.
   Tap the sound icon to unmute a single clip (others re-mute). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scope) {
    var tracks = (scope || document).querySelectorAll('[data-ugc-autoplay]');
    tracks.forEach(function (track) {
      var autoplay = track.dataset.ugcAutoplay === 'true';
      var videos = Array.prototype.slice.call(track.querySelectorAll('video'));
      if (!videos.length) return;

      // Sound toggles
      track.querySelectorAll('[data-ugc-sound]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var media = btn.parentElement.querySelector('video');
          if (!media) return;
          var unmute = media.muted;
          videos.forEach(function (v) { v.muted = true; });
          track.querySelectorAll('[data-ugc-sound]').forEach(function (b) { b.classList.remove('is-on'); });
          if (unmute) {
            media.muted = false;
            media.play();
            btn.classList.add('is-on');
          }
        });
      });

      if (!autoplay || reduce || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.6 });

      videos.forEach(function (v) { io.observe(v); });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
